const Supplier = [
  {
    path: '/ecommerce/supply',
    name: 'supplier',
    component: () => import(/* webpackChunkName: "supplier-base" */ './SupplierView.vue'),
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        {
          name: 'Suppliers',
          path: '/ecommerce/supply/suppliers',
        },
      ],
    },
    children: [
      {
        path: 'suppliers',
        name: 'suppliers',
        component: () => import(/* webpackChunkName: "supplier-all" */ './components/Suppliers.vue'),
        meta: {
          breadCrumbs: [
            {
              name: 'Suppliers',
              path: '/ecommerce/supply/suppliers',
            },
          ],
        },
      },
      {
        path: 'suppliers/new',
        name: 'new-supplier',
        component: () => import(/* webpackChunkName: "new-supplier" */ './components/NewSuppliers.vue'),
        meta: {
          breadCrumbs: [
            {
              name: 'New Supplier',
              path: '/ecommerce/supply/suppliers/new',
            },
          ],
        },
      },
      {
        path: 'suppliers/:id/details',
        name: 'supplier-details',
        component: () => import(/* webpackChunkName: "details-supplier" */ './components/SupplierDetails.vue'),
        meta: {
          requiresAuth: true,
          breadCrumbs: [
            {
              name: 'Supplier Details',
              path: '/ecommerce/supply/suppliers/:id/details',
            },
          ],
        },
      },
      {
        path: 'suppliers/:id/edit',
        name: 'edit_supplier',
        component: () => import(/* webpackChunkName: "edit-supplier" */ './components/UpdateSuppliers.vue'),
        meta: {
          requiresAuth: true,
          breadCrumbs: [
            {
              name: 'Edit Supplier',
              path: '/ecommerce/supply/suppliers/:id/edit',
            },
          ],
        },
      },
    ],
  },
];

export default Supplier;
